import queryString from 'query-string';

export default {
  audiences() {
    return '/audiences';
  },

  audienceNew(subtype, query = {}) {
    const base = `${this.audiences()}/new`;

    if (!subtype) {
      return base;
    }

    const subTypeBase = `${base}/${subtype.replace(/_/g, '-')}`;

    if (Object.keys(query).length) {
      return `${subTypeBase}?${queryString.stringify(query)}`;
    }

    return subTypeBase;
  },

  audienceNewSyncStep(subtype, query = {}) {
    const base = this.audienceNew(subtype);

    if (Object.keys(query).length) {
      return `${base}/sync?${queryString.stringify(query)}`;
    }

    return `${base}/sync`;
  },

  audience(id) {
    if (!id) {
      return;
    }

    return `${this.audiences()}/${id}`;
  },

  audienceEdit(id) {
    if (!id) {
      return;
    }

    return `${this.audience(id)}/edit`;
  },

  audienceClone(id) {
    if (!id) {
      return;
    }

    return `${this.audience(id)}/clone`;
  },

  audienceCloneSyncStep(id) {
    const base = this.audienceClone(id);

    return `${base}/sync`;
  },

  audiencesAccess() {
    return '/audiences/access';
  },

  audiencesAccessRequest() {
    return '/audiences/access/request';
  },

  configurations() {
    return '/settings/configuration';
  },

  configuration(typeOrTypename) {
    return `${this.configurations()}/${typeOrTypename}`;
  },

  configurationConnect(typeOrTypename) {
    return `${this.configuration(typeOrTypename)}/connect`;
  },

  companies() {
    return '/companies';
  },

  company(id, segmentId) {
    return segmentId
      ? `/companies/segments/${segmentId}/${id}`
      : `/companies/${id}`;
  },

  dataEnrichmentIndex() {
    return '/enrichment';
  },

  dataEnrichmentAccess() {
    return '/enrichment/access';
  },

  dataEnrichmentAccessRequest() {
    return '/enrichment/access/request';
  },

  dataEnrichmentConnect(integration) {
    return `/enrichment/${integration}/connect`;
  },

  dataEnrichment(integration) {
    return `/enrichment/${integration}`;
  },

  dataEnrichmentLogs(integration) {
    return `/enrichment/${integration}/logs`;
  },

  dataEnrichmentLog(integration, id) {
    return `${this.dataEnrichmentLogs(integration)}/${id}`;
  },

  dataEnrichmentObject(integration, objectType) {
    return `/enrichment/${integration}/${objectType}`;
  },

  forms() {
    return '/forms';
  },

  formsAccess() {
    return '/forms/access';
  },

  formsAccessRequest() {
    return '/forms/access/request';
  },

  formsIntegration(integration) {
    return `/forms/${integration}`;
  },

  idealCustomerProfile() {
    return '/ideal-customer-profile';
  },

  idealCustomerProfileNew() {
    return '/ideal-customer-profile/new';
  },

  people() {
    return `/people`;
  },

  person(id, segmentId) {
    return segmentId ? `/people/segments/${segmentId}/${id}` : `/people/${id}`;
  },

  segments(typeOrTypename) {
    return segmentRootPaths[typeOrTypename];
  },

  segmentNew(typeOrTypename) {
    const rootPath = segmentRootPaths[typeOrTypename];
    return `${rootPath}/segments/new`;
  },

  segment(typeOrTypename, id) {
    const rootPath = segmentRootPaths[typeOrTypename];
    if (!id) return `${rootPath}`;
    return `${rootPath}/segments/${id}`;
  },

  segmentEdit(typeOrTypename, id) {
    return `${this.segment(typeOrTypename, id)}/edit`;
  },

  segmentDestinations(typeOrTypename, segmentId) {
    return `${this.segment(typeOrTypename, segmentId)}/destinations`;
  },

  segmentDestinationNew(typeOrTypename, segmentId, { type }) {
    return `${this.segmentDestinations(
      typeOrTypename,
      segmentId,
    )}/new?type=${type}`;
  },

  segmentDestinationEdit(typeOrTypename, segmentId, id) {
    return `${this.segmentDestinations(typeOrTypename, segmentId)}/${id}/edit`;
  },

  segmentDestinationContact(typeOrTypename, segmentId, id) {
    return `${this.segmentDestinations(
      typeOrTypename,
      segmentId,
    )}/${id}/contact-success`;
  },

  importCsv(type) {
    return `${segmentRootPaths[type]}/import`;
  },

  mapCsv(type, id) {
    return `${segmentRootPaths[type]}/import/${id}`;
  },
};

const segmentRootPaths = {
  CompanySegment: '/companies',
  PersonSegment: '/people',
  Company: '/companies',
  Person: '/people',
};
